import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { useScreenInit } from './useScreenInit';
import { AppShell } from './components/layout/AppShell';
import { Dashboard } from './pages/Dashboard';
import { EventLog } from './pages/EventLog';
import { ProspectDatabase } from './pages/ProspectDatabase';
import { ManualDNC } from './pages/ManualDNC';
import { RefreshJobs } from './pages/RefreshJobs';
import { Reassignment } from './pages/Reassignment';
import { Connections } from './pages/Connections';
import { Accounts } from './pages/Accounts';
import { SystemMonitoring } from './pages/SystemMonitoring';
export function App() {
  return <BrowserRouter data-id="element-0">
      <AppContent data-id="element-1" />
    </BrowserRouter>;
}
function AppContent() {
  useScreenInit();
  return <AppShell data-id="element-2">
      <Routes data-id="element-3">
        <Route path="/" element={<Dashboard data-id="element-5" />} data-id="element-4" />
        <Route path="/events" element={<EventLog data-id="element-7" />} data-id="element-6" />
        <Route path="/prospects" element={<ProspectDatabase data-id="element-9" />} data-id="element-8" />
        <Route path="/manual-dnc" element={<ManualDNC data-id="element-11" />} data-id="element-10" />
        <Route path="/refresh-jobs" element={<RefreshJobs data-id="element-13" />} data-id="element-12" />
        <Route path="/reassignment" element={<Reassignment data-id="element-15" />} data-id="element-14" />
        <Route path="/connections" element={<Connections data-id="element-17" />} data-id="element-16" />
        <Route path="/accounts" element={<Accounts data-id="element-19" />} data-id="element-18" />
        <Route path="/monitoring" element={<SystemMonitoring data-id="element-21" />} data-id="element-20" />
      </Routes>
    </AppShell>;
}